<template>
  <div class="map-container">
    <google-map
      :crashCar="[crashCar]" :screen="screen" :path="path" :style="{ position: 'absolute' }" />
  </div>
</template>

<script>
import { useRoute } from 'vue-router';
import GoogleMap from '../components/GoogleMap.vue';
import { isEmpty } from 'lodash';
import productService from '../services/product';

export default {
  components: {
    GoogleMap,
  },
  data() {
    return {
      path: [],
      crashCar: {},
      pin: '',
      screen: '',
    };
  },
  created() {
    window.mapView = this;
  },
  async mounted() {
    const route = useRoute();
    if (isEmpty(route.query)) return;

    const pathId = route.query.path_id;
    const screen = route.query?.screen;
    
    if (pathId) {  
      try {
        const res = await productService.fetchVideo(pathId);
        if (res.r && res.track_list) {
          //alert('test ' + res.track_list.map(m=>m.latitude).join(' '))
          //alert('test ' + JSON.stringify(res.event_data, null, 2))
          
          const path = res.track_list.map((item) => ({
            lat: parseFloat(item.latitude),
            lng: parseFloat(item.longitude),
          }));
          
          if(screen === 'crash') {
            this.crashCar = {
              lat: parseFloat(res.event_data.latitude || 0),
              lng: parseFloat(res.event_data.longitude || 0),
            }
          }

          this.update(path, screen);
          return;
        }
      } catch (e) {
        alert('test error ' + e.message)
        console.error(e);
      }
    }

    const p = route.query.p;

    if (p) {
      const pArray = Array.isArray(p) ? p : [p];
      const path = pArray.map((item) => ({ lat: parseFloat(item.split(',')[0]), lng: parseFloat(item.split(',')[1]) }));

      if(screen === 'crash') {
        this.crashCar = path[path.length - 1];
      }
      
      this.update(path, screen);
    }
  },
  methods: {
    update(path, screen) {
      if (!Array.isArray(path)) {
        console.log('path is not array');
        return;
      }
      this.path = path;
      this.screen = screen;
    },
  },
};
</script>

<style lang="scss" scoped>
.map-container {
  width: 100%;
  height: 100%;
}
</style>
